import { render } from "./ConversationCreate.vue?vue&type=template&id=37bd60b6"
import script from "./ConversationCreate.vue?vue&type=script&lang=js"
export * from "./ConversationCreate.vue?vue&type=script&lang=js"

import "./ConversationCreate.vue?vue&type=style&index=0&id=37bd60b6&lang=css"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__